<template>
  <div class="page-about-project">
<!--      <vue-headful
        title="Um okkur | bilaskra.is"
        description="Finndu nýjan bíl á tilteknu verði, af tiltekinni stærð eða gerð og berðu saman kostina sem umboðin bjóða."
        :image="`${imageURL}phones2.png`"
      />-->

      <SecBanner :imgURL="imageURL"></SecBanner>
      <SecPriceTime :imgURL="imageURL"></SecPriceTime>
      <SecAboutWeb :imgURL="imageURL"></SecAboutWeb>
      <SecTerms></SecTerms>

    <Footer v-if="isIosApp" />
  </div>
</template>
<!---->
<script>
import SecBanner from "@/components/AboutProject/Banner"
import SecPriceTime from "@/components/AboutProject/PriceTime"
import SecAboutWeb from "@/components/AboutProject/AboutWeb"
import SecTerms from "@/components/AboutProject/Terms"
import Footer from "@/components/Footer";
import {mapGetters} from "vuex";

export default {
  metaInfo() {
    return {
      title: 'Um okkur',
      titleTemplate: '%s | bilaskra.is',
      meta: [
        {name: 'og:title', content: 'Um okkur' },
        {
          name: 'og:description',
          content: 'Þú getur sett af stað verðvakt sem fylgist með verðbreytingum og lætur þig vita ef verðið á draumabílnum lækkar eða hagstæð tilboð bjóðast.'
        },
        {name: 'og:image', content: '/img/share2.png'},
        {name: 'og:image:height', content: 800},
        {name: 'og:image:width', content: 1200},
      ],
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
    components: {
        SecBanner,
        SecPriceTime,
        SecAboutWeb,
        SecTerms,
        Footer
    },
    data: () => ({
        imageURL: 'https://img.bilaskra.is/img/page-about-project/',
    }),
    mounted() {
      window.scrollTo(0,0)
      document.dispatchEvent(new Event('renderer-ready'));
    },
  computed:{
    ...mapGetters(["isIosApp"]),
  }
}
</script>